module.exports = __webpack_public_path__ + "img/not_found.dc3b2e4b.svg";